<!-- Theme Color Select Button Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    <p-selectButton id="{{ name }}"
      ariaLabelledBy="{{ name }}_label"
      formControlName="{{ name }}"
      [disableControl]="disabled"
      [options]="FlatModels.ColorConfigModels.themeColorList"
      optionLabel="name"
      optionValue="value"
      [ngClass]="{
        'ng-invalid': control.invalid && control.touched,
        'ng-dirty': control.invalid && control.touched
      }"
      (onChange)="valueChange.emit($event)">
      <ng-template let-item>
        <div class="w-2rem h-1rem border-round-sm mr-2"
        [style.background-color]="item.hexValue"></div>
        <span class="p-button-label">{{ item.name }}</span>
      </ng-template>
    </p-selectButton>
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}